<template>
    <a-card>
        <div @keydown.enter='getPageList(1)'>
            <a-form-model layout="inline" class="search-form" :model="searchForm" >
            <a-form-model-item label="所属机构">
                <a-select :filter-option="filterOption"
                          allowClear showSearch
                          v-model="searchForm.organizationId"
                          placeholder="请选择">
                    <a-select-option :value="item.id" v-for="item in organizationList">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="课程类型">
                <a-select allowClear v-model="searchForm.courseType" placeholder="请选择">
                    <a-select-option value="1">测评课程</a-select-option>
                    <a-select-option value="2">训练课程</a-select-option>
                    <a-select-option value="3">活动课程</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="课程名称">
                <a-input :maxLength="30" v-model.trim="searchForm.courseName" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="资源名称">
                <a-input :maxLength="30" v-model.trim="searchForm.resourceName" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="课程状态">
                <a-select allowClear v-model="searchForm.statuses" placeholder="请选择">
                    <a-select-option value="0">未开始</a-select-option>
                    <a-select-option value="1">进行中</a-select-option>
                    <a-select-option value="2">已完成</a-select-option>
                    <a-select-option value="3">已过期</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="状态">
                <a-select allowClear v-model="searchForm.enabled" placeholder="请选择">
                    <a-select-option value="true">启用</a-select-option>
                    <a-select-option value="false">禁用</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item style="margin-right: 35px;">
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                    查询
                </a-button>
                <a-button @click="searchReset" style="margin-left: 10px;">
                    重置
                </a-button>
            </a-form-model-item>
            <a-form-model-item v-permission="`CourseManage.Merge`">
                <a-button type="primary" @click="mergeCourse" icon="fork">合并课程</a-button>
            </a-form-model-item>
            <a-form-model-item v-permission="`CourseManage.UpdateScore`">
                <a-button type="primary" @click="updateScoreShow" icon="history">重算分数</a-button>
            </a-form-model-item>
        </a-form-model>
        </div>
        <a-table
            style="min-width: 800px;"
            :columns="columns"
            :row-key="text => JSON.stringify(text)"
            :row-selection="rowSelection"
            :pagination="tableRelevant.tablePagination"
            :loading="tableRelevant.tableLoading"
            :locale="tableRelevant.locale"
            :dataSource="tableRelevant.tableDataSource">
            <div slot="name" slot-scope="text, record">
                <span v-if='text.source == 1' class="tag">区域</span>
                {{ text.name }}
            </div>
            <div slot="courseStatus" slot-scope="text, record">
                <span v-if="text.status == 0">未开始</span>
                <span v-else-if="text.status == 1 " style="color: #ffa905">进行中</span>
                <span v-else style="color: #13c2c2">已完成</span>
            </div>
            <div slot="courseResourceName" slot-scope="text, record">
                {{ text.courseResourceName + (text.period ? (" - " + text.period) : "") }}
            </div>
            <div slot="progress" slot-scope="text, record">
              <a-badge v-if="text.statusName === '未开始'" status="warning"/>
              <a-badge v-if="text.statusName === '进行中'" status="processing"/>
              <a-badge v-if="text.statusName === '已完成'" status="success"/>
              <a-badge v-if="text.statusName === '已过期'" status="default"/>
              {{ text.statusName }}
              <check-circle-filled v-if="text.statusName === '已完成'" style="color: #52c41a; margin-left: 5px"/>
              <span v-if="!['未开始', '已完成'].includes(text.statusName)" style="margin-left: 5px">{{text.progress }}%</span>
            </div>
            <div slot="completionRate" slot-scope="text, record">
                {{ text.completionRate }}%
            </div>
            <div slot="statusName" slot-scope="text, record">
                <span>{{ text.statusName }}</span>
            </div>
            <div slot="enabled" slot-scope="text, record" v-auth="`CourseManage.Enabled`">
                <a-switch :disabled="!text.canOperate" @change="tableEnabledChange(text)" :checked="text.enabled" checked-children="启用"
                          un-checked-children="禁用"/>
            </div>
            <div slot="uneffectiveDate" slot-scope="text">
                {{ text.uneffectiveDate }}
            </div>
            <div slot="action" class="action" slot-scope="text, record">
                <a-button type="link" icon="bars" v-permission="`CourseManage.Details`"
                :disabled="!text.canOperate"
                          @click="toPath(text, `/projectImpl/CourseManage/details`)">
                    课程详情
                </a-button>
                <a-popconfirm :disabled="!text.canOperate" title="确认要删除此课程吗？" @confirm="del(text)"
                              ok-text="确认" cancel-text="取消">
                    <a-button :disabled="!text.canOperate" type="link" icon="delete"  class="c-red" v-permission="`CourseManage.Delete`">
                        删除
                    </a-button>
                </a-popconfirm>
            </div>
        </a-table>
        <!--课程码-->
        <a-modal
            v-model="courseCode.visible"
            :centered="true"
            :destroyOnClose="true"
            :title="`查看课程码（生效时间 ${courseCode.effectDate}）`"
            @ok="courseCode.visible = false" width="800px">
            <CourseCodePage
                :codeType="courseCode.codeType"
                :exportExcel="true"
                :params="courseCode.params"
                @effectDate="effectDate => courseCode.effectDate = effectDate"/>
        </a-modal>

        <!-- 合并课程 -->
        <a-modal
            :maskClosable="true"
            @cancel="closeMergeList"
            width="90%"
            title="合并课程"
            :visible="merge.visible"
            :confirm-loading="merge.confirmLoading">
            <template slot="footer" v-if="merge.step == 0">
                <a-button key="back" @click="closeMergeList">上一步</a-button>
                <a-button key="submit" @click="getStudent()" type="primary">下一步</a-button>
            </template>
            <template slot="footer" v-if="merge.step == 1">
                <a-button key="back" @click="merge.step = 0">上一步</a-button>
                <a-button key="submit" type="primary" @click="submitMerge">提交合并</a-button>
            </template>
            <!--            <template slot="footer" v-if="merge.step == 2">
                            <a-button key="back" @click="merge.step = 1">上一步</a-button>
                            <a-button key="submit" type="primary" @click="submitMerge">提交合并</a-button>
                        </template>-->
            <a-steps :current="merge.step" size="small">
                <a-step title="选择主体课程"/>
                <a-step title="选择学生进度"/>
                <a-step title="完成"/>
            </a-steps>
            <div v-show="merge.step == 0">
                <p style="font-weight: bold;font-size: 16px;margin: 30px 0 15px 0;">选择合并主体<span
                    style="font-weight: normal;color: #bbb;font-size: 14px;margin-left: 5px;">合并后信息以主体为准，包括课程基本信息、开课规则、学生年级班级、课程码等信息</span>
                </p>
                <a-table
                    :scroll="{y: 350}"
                    :row-selection="mergeOneRowKeys"
                    style="min-width: 800px;"
                    :columns="mergeOneColumns"
                    row-key="id"
                    :dataSource="merge.oneData">
                    <div slot="courseStatus" slot-scope="text, record">
                        <span v-if="text.status == 0">未开始</span>
                        <span v-else-if="text.status == 1 " style="color: #ffa905">进行中</span>
                        <span v-else style="color: #13c2c2">已完成</span>
                    </div>
                    <div slot="courseResourceName" slot-scope="text, record">
                        {{ text.courseResourceName + (text.period ? (" - " + text.period) : "") }}
                    </div>
                    <div slot="progress" slot-scope="text, record">
                        <a-badge v-if="getCourseType(text) === 2" status="success"/>
                        <a-badge v-if="getCourseType(text) === 3" status="default"/>
                        <a-badge v-if="getCourseType(text) === 1" status="processing"/>
                        <a-badge v-if="getCourseType(text) === 0" status="warning"/>
                        {{ courseProgressTypes[getCourseType(text)] }}
                        <a-icon type="check-circle" v-if="getCourseType(text) === 2"
                                style="color: #52c41a; margin-left: 5px"/>
                        <span v-if="![0, 2].includes(getCourseType(text))" style="margin-left: 5px">{{
                                text.progress
                            }}%</span>
                    </div>
                    <div slot="completionRate" slot-scope="text, record">
                        {{ text.completionRate }}%
                    </div>
                    <div slot="statusName" slot-scope="text, record">
                        <span>{{ text.statusName }}</span>
                    </div>
                    <span slot="enabled" slot-scope="text, record">
                        {{ text.enabled ? '启用' : '禁用' }}
                    </span>
                    <span slot="uneffectiveDate" slot-scope="text">
                        {{ text.uneffectiveDate }}
                    </span>
                </a-table>
            </div>
            <div v-show="merge.step == 1 && !merge.tableRelevant.tableDataSource.length">
                <a-result
                    status="success"
                    title="所有学生均不重复，请直接提交"
                >
                </a-result>
            </div>
            <div v-show="merge.step == 1 && merge.tableRelevant.tableDataSource.length">
                <p style="font-weight: bold;font-size: 16px;margin: 30px 0 15px 0;">选择学生进度<span
                    style="font-weight: normal;color: #bbb;font-size: 14px;margin-left: 5px;">每门课程中存在重复学生且课程个人进度不同时，需选择正确的个人进度</span>
                </p>
                <a-table
                    row-key="realName"
                    :key="merge.tableRelevant.key"
                    :scroll="{y: 350}"
                    :columns="mergeTwoColumns"
                    :pagination="merge.tableRelevant.tablePagination"
                    :loading="merge.tableRelevant.tableLoading"
                    :locale="merge.tableRelevant.locale"
                    :data-source="merge.tableRelevant.tableDataSource"
                    :defaultExpandAllRows="true"
                    class="components-table-demo-nested">
                    <span slot="gender" slot-scope="text, record">
                        {{ text.gender == 1 ? '男' : '女' }}
                    </span>
                    <div style="max-width: 250px" slot="className" slot-scope="text, record">
                        <div class="self_td" v-for="(item,index) in record.classNames" :key="item.id">
                            {{ item }}
                        </div>
                    </div>
                    <ChildTable
                        slot="expandedRowRender"
                        :columns="twoChildColumns"
                        :selectUser="text.selectUser"
                        :disabled="text.checked"
                        :key="text.key || Date.now()"
                        @selectUserChange="selectUserChange"
                        :dataSource="text.items"
                        slot-scope="text"></ChildTable>
                </a-table>
            </div>

        </a-modal>

        <a-modal v-model="updateScore.visible"
                 :centered="true"
                 :destroyOnClose="true"
                 title="重算分数"
                 @cancel="updateScoreCancel"
                 @ok="updateScoreOk" width="800px">
            <a-table :columns="updateScore.columns"
                     row-key="contentId"
                     :row-selection="updateScoreSelection"
                     :pagination="updateScore.table.tablePagination"
                     :dataSource="updateScore.table.tableDataSource">
                <div slot="estimatedTime" slot-scope="text, record">
                    {{ EstimatedTime(text.estimatedTime) }}
                </div>
            </a-table>
        </a-modal>
    </a-card>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import CourseCodePage from "./components/CourseCodePage";
import ChildTable from "./components/ChildTable";
import {EstimatedTime} from "@/utils/EstimatedTime";

export default {
    name: "CourseCenter",
    components: {CourseCodePage, ChildTable},
    data() {
        return {
            organizationList: [],
            courseProgressTypes: ['未开始', '进行中', '已完成', '已过期'],
            searchForm: {
                courseName: this.$route.query.courseName,
                resourceName: this.$route.query.resourceName,
                statuses: this.$route.query.statuses,
                enabled: this.$route.query.enabled,
                organizationId: Number(this.$route.query.organizationId) || undefined,
                courseType: this.$route.query.courseType,
            },
            columns: [
                {title: '课程名称', key: "1", scopedSlots: {customRender: 'name'}},
                {title: '所属机构', key: "3", dataIndex: 'organizationName'},
                {title: '资源名称', key: "2", scopedSlots: {customRender: 'courseResourceName'}},
                {title: '学生数', key: "4", dataIndex: 'configuredUserCount'},
                {title: '课程进度', key: "5-1", scopedSlots: {customRender: 'progress'}},
                {title: '完成率', key: "9", scopedSlots: {customRender: 'completionRate'}},
                {title: "状态", key: "6", scopedSlots: {customRender: 'enabled'}},
                {title: '计划结束时间', key: "7", scopedSlots: {customRender: 'uneffectiveDate'}},
                {title: '操作', key: "8", scopedSlots: {customRender: 'action'}}
            ],
            tableRelevant: tableRelevant.call(this),
            courseCode: {
                visible: false,
                effectDate: "",
                codeType: "",
                params: {}
            },
            tableSelectedRows: [],

            mergeListVisible: false,
            mergeListColumns: [
                {title: '课程名称', key: "1", dataIndex: 'name'},
                {title: '资源名称', key: "2", scopedSlots: {customRender: 'courseResourceName'}},
                {title: '备注', key: "3", dataIndex: 'description'},
                {title: '学生数', key: "4", dataIndex: 'configuredUserCount'},
                {title: '课程进度', key: "5-1", scopedSlots: {customRender: 'progress'}, width: 200},
                {title: '完成率', key: "9", scopedSlots: {customRender: 'completionRate'}, width: 200},
                {title: "状态", key: "6", scopedSlots: {customRender: 'enabled'}},
                {title: '计划结束时间', key: "7", scopedSlots: {customRender: 'uneffectiveDate'}},
            ],
            mergeOneColumns: [
                {title: '课程名称', key: "1", dataIndex: 'name'},
                {title: '资源名称', key: "2", scopedSlots: {customRender: 'courseResourceName'}},
                {title: '备注', key: "3", dataIndex: 'description'},
                {title: '学生数', key: "4", dataIndex: 'configuredUserCount'},
                {title: '课程进度', key: "5-1", scopedSlots: {customRender: 'progress'}, width: 200},
                {title: '完成率', key: "9", scopedSlots: {customRender: 'completionRate'}, width: 200},
                {title: '计划结束时间', key: "7", scopedSlots: {customRender: 'uneffectiveDate'}},
            ],
            mergeTwoColumns: [
                {title: '姓名', key: "1", dataIndex: 'realName'},
                {title: '性别', key: "2", scopedSlots: {customRender: 'gender'}},
                {title: '年级', key: "3", dataIndex: 'gradeName'},
                {title: '班级', key: "4", scopedSlots: {customRender: 'className'}, class: 'testClass',},
                {title: '出生日期', key: "5", dataIndex: 'birthday'},
            ],
            twoChildColumns: [
                {title: '课程名称', key: "1", dataIndex: 'customerCourseName'},
                {title: '个人进度', key: "2", scopedSlots: {customRender: 'progress'}},
                {title: '个人状态', key: "3", dataIndex: 'progressName'},
                {title: '更新时间', key: "4", dataIndex: 'updateTime'},
            ],
            merge: {
                visible: false,
                confirmLoading: false,
                step: 0,
                oneData: [],
                rowKeys: [],
                studentRowKeys: [],
                courseType: undefined,
                organizationId: undefined,
                tableRelevant: tableRelevant.call(this),
                searchForm: {
                    courseName: undefined,
                    resourceName: undefined,
                    statuses: undefined,
                },
            },
            expandedRowKeys: [],

            // 重新算分
            updateScore: {
                visible: false,
                confirmLoading: false,
                columns: [
                    {title: '内容名称', dataIndex: 'contentName'},
                    {title: '预计用时', scopedSlots: {customRender: 'estimatedTime'}},
                ],
                table: tableRelevant.call(this),
                selectedRowKeys: []
            }
        }
    },
    computed: {
        rowSelection() {
            return {
                selectedRowKeys: this.tableSelectedRows,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.tableSelectedRows = selectedRowKeys;
                },
                getCheckboxProps:(record)=>({
                        props:{
                           disabled:!record.canOperate
                        }
                })
            };
        },
        updateScoreSelection() {
            return {
                selectedRowKeys: this.updateScore.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.updateScore.selectedRowKeys = selectedRowKeys;
                }
            };
        },
        mergeOneRowKeys() {
            return {
                type: "radio",
                selectedRowKeys: this.merge.rowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.merge.rowKeys = selectedRowKeys;
                },
            };
        },
    },
    created() {
        this.getPageList();
        this.getAllOrg();
    },
    methods: {
        EstimatedTime,
        getCourseType(val) {
            if (val.progress >= 100) {
                return 2
            }
            if (new Date(val.uneffectiveDate).getTime() < Date.now()) {
                return 3
            }
            if (val.progress <= 0) {
                return 0
            }
            return 1
        },
        filterOption(input, option) {
            const re = new RegExp(`[${input}]`, 'g');
            const match = option.componentOptions.children[0].text.match(re) || [];
            return match.length >= input.length;
        },
        // 获取机构列表
        getAllOrg() {
            this.$http.loadAllByType({
                type: 0
            }).then(res => {
                const { data } = res.data;
                this.organizationList = data;
            })
        },
        selectUserChange(selectedRowKeys, selectedRows) {
            console.log(selectedRowKeys, selectedRows);
            this.merge.tableRelevant.tableDataSource.forEach(v => {
                if (v.realName == selectedRows[0].realName) {
                    v.selectUser = selectedRowKeys
                }
            })
        },
        // 合并课程
        mergeCourse() {
            this.$message.destroy();
            if (this.tableSelectedRows.length < 2) {
                this.$message.warning("请至少选择2个课程");
                return
            }
            const tableData = this.tableSelectedRows.map(m => {
                const item = JSON.parse(m);
                return item;
            });
            if (tableData.filter(f => f.organizationId !== tableData[0].organizationId || f.projectCourseResourceId !== tableData[0].projectCourseResourceId).length) {
                this.$message.warning("请选择同一机构同一资源的课程");
                return;
            }
            console.log(tableData);
            this.merge.oneData = tableData;
            this.merge.visible = true;
        },
        // 取消合并
        closeMergeList() {
            this.merge.visible = false
            this.merge.organizationId = undefined
            this.merge.courseType = undefined
            this.tableSelectedRows = []
            this.merge.rowKeys = []
            this.merge.studentRowKeys = []
            this.merge.tableRelevant.tableDataSource = []
            this.tableRelevant.tablePagination.current = 1;
            this.merge.step = 0
            this.getPageList(1)
        },

        // 合并获取学生
        getStudent() {
            this.$message.destroy();
            if (!this.merge.rowKeys.length) {
                this.$message.warning("请选择合并主体");
                return
            }
            let params = {
                customerCourseIds: this.merge.oneData.map(m => m.id),
                mainCourseId: this.merge.rowKeys[0]
            }
            this.$http.Course.CheckMergeCustomerCourse(params)
                .then(res => {
                    const { data } = res;
                    data.forEach((v, i) => {
                        this.expandedRowKeys.push(v.realName)
                        v.users = []
                        v.items.forEach(m => {
                            v.users.push(m.customerCourseId);
                            m.realName = v.realName;
                            if (this.merge.rowKeys[0] == m.customerCourseId) {
                                v.selectUser = [m.customerCourseId];
                            }
                        })
                    })
                    this.merge.tableRelevant.tableDataSource = data
                    this.merge.tableRelevant.key = Date.now();
                    this.merge.tableRelevant.tablePagination.total = data.length
                    this.merge.step = 1
                })
        },
        submitMerge() {
            let params = {
                customerCourseIds: this.merge.oneData.map(m => m.id),
                mainCourseId: this.merge.rowKeys[0],
                items: this.merge.tableRelevant.tableDataSource.map(m => ({
                    organizationUserId: m.organizationUserId,
                    customerCourseId: m.selectUser[0]
                }))
            }
            this.$http.Course.MergeCustomerCourse(params)
                .then(res => {
                    this.$message.success('操作成功');
                    this.closeMergeList();
                    this.getPageList(1)
                })
        },

        //获取课程列表
        getPageList(pageIndex) {
            const params = {
                pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
                ...this.searchForm
            };
            this.$router.push({
                query: {
                    ...this.$route.query,
                    ...this.searchForm
                }
            });
            this.tableRelevant.tableLoading = true;
            this.$http.TwoB.getCoursePageList(params).then(res => {
                const { data } = res;
                this.tableRelevant.tableDataSource = data.items.map(m => ({...m, checked: true}));
                this.tableRelevant.tablePagination.total = data.totalCount;
                this.tableRelevant.tablePagination.current = data.pageIndex;
            }).finally(() => {
              this.tableRelevant.tableLoading = false;
            })
        },
        //重置
        searchReset() {
            for (let key in this.searchForm) {
                this.searchForm[key] = undefined;
            }
            this.getPageList(1);
        },
        toPath(val, path) {
            this.$store.commit('organization/setCourseInfo', val);
            this.$router.push({
                path,
                query: {
                    id: val.id,
                    fullPath: window.encodeURIComponent(this.$route.fullPath)
                }
            });
        },
        //删除课程
        del(text) {
            this.$message.destroy();
            if (text.source == 1) {
                this.$message.warning('区域项目禁止删除')
                return
            }
            this.$confirm({
                title: `确认删除该课程？`,
                content: "课程删除后所有相关数据都将删除且不可恢复，请谨慎操作",
                centered: true,
                cancelText: '取消',
                okText: '确认',
                onOk: () => {
                    const Data = new URLSearchParams({"projectCourseConfigId": text.id});
                    this.tableRelevant.tableLoading = true;
                    this.$http.Course.courseDelete(Data).then(res => {
                        const { message } = res;
                        this.$message.success(message);
                        this.getPageList(1);
                    }).finally(() => {
                      this.tableRelevant.tableLoading = false;
                    })
                }
            });

        },
        //启用禁用课程
        tableEnabledChange(val) {
            this.$message.destroy();
            let text = val.enabled ? '禁用' : '启用'
            if (val.source == 1) {
                this.$message.warning('区域项目禁止' + text)
                return
            }
            const formData = new FormData();
            formData.append("id", val.id);

            this.tableRelevant.tableLoading = true;
            this.$http.Course.courseUpdate(formData).then(res => {
                    this.$message.success(res.message);
                    val.enabled = !val.enabled;
               
            }).finally(() => {
              this.tableRelevant.tableLoading = false;
            })
        },
        //课程码
        lookCourseCode(val) {
            this.$http.UserManage.hasCourseCode({ProjectCourseConfigId: val.id}).then(res => {
                const { data, message } = res;
                this.courseCode.codeType = val.codeType;
                this.courseCode.params = {
                    projectCourseConfigId: val.id,
                    showCode: 1
                };
                if (!data) {
                    this.$message.destroy();
                    this.$message.error(message)
                } else {
                    this.courseCode.visible = true;
                }
            });
        },

        updateScoreShow() {
            this.$message.destroy();
            if (!this.tableSelectedRows.length) {
                this.$message.warning("请选择课程");
                return
            }
            const tableData = this.tableSelectedRows.map(m => {
                const item = JSON.parse(m);
                return item.id;
            });
            this.$http.TwoB.getCustomerCourseEvaluationContents({
                customerCourseIds: tableData,
            }).then(res => {
                const { data } = res;
                this.updateScore.table.tableDataSource = data;
                this.updateScore.visible = true;
            })
        },
        updateScoreOk() {
            this.$message.destroy();
            if (!this.updateScore.selectedRowKeys.length) {
                this.$message.warning("请选择要算分的内容");
                return
            }
            const Params = {
                customerCourseIds: this.tableSelectedRows.map(m => JSON.parse(m).id),
                contentIds: this.updateScore.selectedRowKeys
            }
            this.updateScore.confirmLoading = true;
            this.$http.CourseCenter.updateCourseContentScores(Params).then(res => {
                const { message } = res;
                this.$message.success(message);
                this.updateScoreCancel();
            }).finally(() => {
              this.updateScore.confirmLoading = false;
            })
        },
        updateScoreCancel() {
            this.updateScore.selectedRowKeys = [];
            this.tableSelectedRows = [];
            this.updateScore.visible = false;
        }
    }
}
</script>

<style scoped>
.serach-item {
    width: 180px;
    margin-bottom: 15px;
}

/deep/ .ant-result-title {
    font-size: 20px;
}

/deep/ .ant-table-tbody .testClass {
    padding: 0 !important;
}

.self_td {
    height: 54px;
    display: flex;
    align-items: center;
    padding: 0 16px;
}

.tags {
    display: none;
}

.self_td:hover .tags {
    display: block;
}

.tag {
    padding: 0px 5px;
    border: 1px solid #1890ff;
    border-radius: 5px;
    color: #1890ff;
}
</style>
